import { apiFetcher } from '@/api/api'
import { useCacheSWR } from '@/api/swrCache'
import useSWRMutation from 'swr/mutation'

export function useVipCfgList() {
  const fetcher = () => {
    return apiFetcher(
      {
        path: '/site/api/v1/user/member/memberGradeConfigList',
        type: 'post'
      },
      {
        arg: {}
      }
    )
  }
  const result = useCacheSWR('useVipCfgList',fetcher,{dedupingInterval: 20 * 1000,author: true})
  const data = result.data?.data
  return{
    ...result,
    data
  }
}

//获取vip晋级优惠配置
export function useVipPromotionList(vipGrade){
  const vipGradeStr = vipGrade?.toString()
  const fetcher = () => {
    return apiFetcher(
      {
        path: '/act/api/v1/promotion/config',
        type: 'post'
      },
      {
        arg: {
          vipGrade: vipGradeStr
        }
      }
    )
  }
  const result = useCacheSWR('useVipPromotionList' + vipGradeStr,vipGrade ? fetcher : null,{dedupingInterval: 10 * 1000,author: true})
  const data = result.data?.data
  return {
    ...result,
    data
  }
}

//校验vip礼金是否可以领取
export function useCheckBonusEligibility() {
  const params = {
    path: '/act/api/v1/promotion/verification',
    type: 'post'
  }
  const result = useSWRMutation(params, (params, arg: { arg: any }) => {
    return apiFetcher<any>(params, { ...arg })
  })
  return result
}

//领取vip礼金
export function useReceiveVipBonus() {
  const params = {
    path: '/act/api/v1/promotion/confirmInfo',
    type: 'post'
  }
  const result = useSWRMutation(params, (params, arg: { arg: any }) => {
    return apiFetcher<any>(params, { ...arg })
  })
  const data = result.data?.data
  return {
    ...result,
    data
  }
}

//领取vip礼金
export function useJoinActivityVipBonus() {
  const params = {
    path: '/act/api/v1/promotion/joinActivity',
    type: 'post'
  }
  const result = useSWRMutation(params, (params, arg: { arg: any }) => {
    return apiFetcher<any>(params, { ...arg })
  })
  const data = result.data?.data
  return {
    ...result,
    data
  }
}

//vip返水
export function useGetGameFanshuiHighLow(){
  const fetcher = () => {
    return apiFetcher(
      {
        path: '/site/api/v1/user/member/getGameFanshuiHighLow',
        type: 'post',
      },
      {
        arg: {}
      }
    )
  }
  const result = useCacheSWR('useGetGameFanshuiHighLow', fetcher, {
    dedupingInterval: 15 * 1000,author: true
  })
  const data = result.data?.data
  return {
    ...result,
    data
  }
}

//VipWeekInfo VIP福利
export function useVipWeekInfo() {
  const fetcher = () => {
    return apiFetcher(
      {
        path: '/act/api/v1/vipWeek/VipWeekInfo',
        type: 'post'
      },
      {
        arg: {}
      }
    )
  }
  const result = useCacheSWR('useVipWeekInfo', fetcher, {
    dedupingInterval: 5 * 60 * 1000,
    author: true
  })
  const data = result.data?.data
  return {
    ...result,
    data
  }
}